export const logger = {
  error: (scope: string, err: unknown) => {
    if (process.env.NODE_ENV !== 'production') {
      console.error(`[${scope}]`, err);
    }
  },
};
